import { Actions, ActionTypes } from './actions';
import { problemAdapter, initialState, ProblemState } from './state';

export function problemReducer(state = initialState, action: Actions): ProblemState {
  switch (action.type) {
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    case ActionTypes.LOAD_REQUEST:
    case ActionTypes.SAVE_REQUEST:
    case ActionTypes.SOLVED_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_SUCCESS: {
      return problemAdapter.upsertMany(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.SAVE_SUCCESS: {
      return problemAdapter.upsertOne(action.item, {
        ...state,
        selected: { ...action.item },
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.CREATE_SUCCESS: {
      return problemAdapter.upsertOne(action.problem, {
        ...state,
        selected: { ...action.problem },
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.DELETE_SUCCESS: {
      return problemAdapter.removeOne(action.id, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.SET_SELECTED_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.SET_SELECTED_SUCCESS: {
      return {
        ...state,
        selected: { ...action.problem },
        isLoading: false,
        error: null,
      };
    }

    case ActionTypes.SOLVED_SUCCESS: {
      return problemAdapter.upsertOne(action.problem, {
        ...state,
        selected: { ...action.problem },
        isLoading: false,
        error: null,
      });
    }

    default: {
      return state;
    }
  }
}
